const spacing = {
  gutters: 17,
};

export default spacing;
